import { configureStore } from "@reduxjs/toolkit";

const initialState = {
  sidebarShow: true,
  returnUrl: "",
  loading: false,
  notificationCount: 0,
  newMessagesCount: 0,
  coachMark: null,
  isLoggedIn: false,
  isAuthenticated: false,
  isChatPanelOpen: false,
  isMobile: false,
  isLoadingChat: false,
  isLoadingChatUsers: false,
};

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case "set":
      return { ...state, ...rest };
    default:
      return state;
  }
};

const store = configureStore({
  reducer: changeState,
  preloadedState: {
    sidebarShow: true,
    returnUrl: "",
    loading: false,
    notificationCount: 0,
    newMessagesCount: 0,
    isCoachMarkVisible: false,
    coachMark: null,
    isChatPanelOpen: false,
    isMobile: false,
    isLoadingChat: false,
    isLoadingChatUsers: false,
  },
});

export default store;
